import * as CheckboxRoot from "@radix-ui/react-checkbox";
import styled, { css } from "styled-components";
import { Flex } from "../Flex";
import { getThemeMedia } from "../helpers";
export const Circle = styled(CheckboxRoot.Root) `
	${({ variant }) => {
    if (variant === 'dark')
        return '--radio-border-color: #262626;';
    if (variant === 'light')
        return '--radio-border-color: var(--surface-white);';
    return '--radio-border-color: var(--border-active);';
}}

	align-items: center;
	display: flex;
	justify-content: center;

	border: 2px solid var(--radio-border-color);
	border-radius: 50%;
	padding: 2px;

	width: 20px;
	height: 20px;
	min-width: 20px;
	min-height: 20px;

	cursor: pointer;
	transition: all 300ms ease-in-out;

	${({ size }) => size === 'small' && css `
		width: 16px;
		height: 16px;
		min-width: 16px;
		min-height: 16px;
	`}

	&:disabled {
		border-color: var(--border-disable);
		color: var(--text-primary);
		cursor: not-allowed;
	}

	@media screen {
		${({ variant }) => variant &&
    Object.keys(variant).map((media) => {
        return css `
					@media (min-width: ${getThemeMedia(media)}) {
						height: calc(${variant[media]} - 2px);
						min-width: calc(${variant[media]} - 2px);
					}
				`;
    })}
	}
`;
export const Indicator = styled(CheckboxRoot.Indicator) `
	border-radius: 50%;

	height: 10px;
	min-height: 10px;
	width: 10px;
	min-width: 10px;

	background-color: var(${({ disabled }) => (disabled ? "--border-primary" : "--radio-border-color")});

	${({ size }) => size === 'small' && css `
		height: 8px;
		min-height: 8px;
		width: 8px;
		min-width: 8px;
	`}
`;
export const Item = styled(Flex) `
	label {
		width: max-content;
	}
`;
//# sourceMappingURL=styles.js.map